import React from 'react';
import { useTheme } from '@creditas-ui/react';
export default function ChevronDown(_a) {
    var _b = _a.color, color = _b === void 0 ? useTheme().colors.neutral[90] : _b;
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M14 5L8 11L2 5", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" })));
}
//# sourceMappingURL=ChevronDown.js.map